export const CHIMNEY_CAPS_TITLE = 'claim.declaration.external_damages.form.chimney.caps.question';
export const CHIMNEY_CAPS_LABEL = 'claim.declaration.external_damages.form.chimney.caps.count';
export const CHIMNEY_STACK_TITLE = 'claim.declaration.external_damages.form.chimney.stack.question';
export const CHIMNEY_STACK_LABEL = 'claim.declaration.external_damages.form.chimney.stack.damaged';
